import { useRef, useState } from "react";
import { HiSpeakerWave, HiSpeakerXMark } from "react-icons/hi2";

// importy wideo
import videoDesktop from "../../../src/assets/video/mash-ad-0.3-b-[final].mp4";
import videoMobile from "../../../src/assets/video/mash-ad-mobile-0.1-b-[final].mp4";

export default function VideoBackground() {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    if (!videoRef.current) return;
    const newMuted = !isMuted;
    setIsMuted(newMuted);
    if (!newMuted) {
      videoRef.current.play().catch(() => {});
    }
  };

  return (
    <div className="h-dvh absolute top-0 left-0 w-full">
      {/* Background video (jedno źródło dla desktop/mobile) */}
      <video
        ref={videoRef}
        autoPlay
        muted={isMuted}
        loop
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
      >
        <source src={videoMobile} media="(max-width: 639px)" type="video/mp4" />
        <source
          src={videoDesktop}
          media="(min-width: 640px)"
          type="video/mp4"
        />
      </video>

      {/* Dark overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-black/50 z-0" />

      {/* Mute/unmute button */}
      <button
        onClick={toggleMute}
        className="absolute bottom-4 right-4 bg-black/50 p-2 rounded-full hover:bg-black/70 z-20"
      >
        {isMuted ? <HiSpeakerXMark size={20} /> : <HiSpeakerWave size={20} />}
      </button>
    </div>
  );
}
